module.exports = __webpack_public_path__ + "static/media/gcp.027c8b39.svg";